<template>
  <span
    class="color-swatch"
    :style="{'background-color': color}" />
</template>

<script>
export default {
  name: 'ColorSwatch',
  props: {
    color: {
      type: String,
      default: '#FFFFFF'
    }
  }
}
</script>

<style lang="scss" scoped>
.color-swatch {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 5px;
  border: 2px solid #333;
}
</style>
